import {EventEmitter, Injectable} from '@angular/core';
import {WebSocketService} from '@app/modules/shared/services/web-socket.service';
import {WrtcService} from '@app/modules/wrtc/services/wrtc.service';
import {LocalUser, LocalUserState} from '@app/state/local-user.state';
import {Store} from '@ngxs/store';
import {AccessType} from '@app/modules/shared/data/constants';

export enum Service {
  VCR,
  WEB_RTC
}

@Injectable({
  providedIn: 'root'
})
export class UserDisconnectionHandlerService {
  public onDisconnect: EventEmitter<Service> = new EventEmitter<Service>();
  public offlineTimer: NodeJS.Timer;

  private localUser: LocalUser;
  private webSocketService: WebSocketService;
  private wrtcService: WrtcService;

  public constructor(private store: Store) {
    this.store.select(LocalUserState).subscribe((localUser: LocalUser): void => {
      this.localUser = localUser;
    });

    this.onDisconnect.subscribe((): void => {
      if (this.localUser.accessType === AccessType.STUDENT && this.localUser.isCurrentClassParticipant) {
        this.startReloadTimer();
      }
    });
  }

  public setWebSocketService(webSocketService: WebSocketService): void {
    this.webSocketService = webSocketService;
  }

  public setWebRTCService(wrtcService: WrtcService): void {
    this.wrtcService = wrtcService;
  }

  private startReloadTimer(): void {
    if (this.offlineTimer) {
      return;
    }

    this.offlineTimer = setTimeout((): void => {
      if (this.webSocketService.isConnected !== this.wrtcService.isConnected) {
        window.location.reload();
      } else {
        clearTimeout(this.offlineTimer);
        this.offlineTimer = undefined;
      }
    }, 60 * 1000);
  }
}
